<template>
  <div class="template">
    <div class="search">
      <div class="search-center">
        <div class="search-item">
          字典名称：
          <Input clearable v-model="search.dictName" placeholder="请输入字典名称" style="width: 150px; margin-left: 10px"></Input>
        </div>
        <div class="search-item">
          字典类型：
          <Input clearable v-model="search.dictType" placeholder="请输入字典类型" style="width: 150px; margin-left: 10px"></Input>
        </div>
        <div class="search-item">
          状态：
          <Select clearable v-model="search.status" placeholder="请选择" style="width: 120px; margin-left: 10px">
            <Option value="0">正常</Option>
            <Option value="1">停用</Option>
          </Select>
        </div>
        <Button style="width: 80px; margin-right: 10px" type="primary" icon="ios-search" @click="searchFn">查询</Button>
        <Button style="width: 80px" @click="clearFn">重置</Button>
      </div>
    </div>
    
    <div class="filter">
      <div class="filter-center">
        <Button style="margin-right: 10px" type="primary" icon="ios-add" @click="handleAdd">新增</Button>
        <Button style="margin-right: 10px" type="error" icon="ios-trash" @click="handleDelete" :disabled="selections.length === 0">删除</Button>
      </div>
    </div>

    <div class="table">
      <Table :columns="columns" :data="tableList" @on-selection-change="handleSelectionChange">
        <template slot-scope="{ row }" slot="status">
          <Tag :color="row.status === '0' ? 'success' : 'default'">{{ row.status === '0' ? '正常' : '停用' }}</Tag>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button type="primary" size="small" @click="handleEdit(row)" style="margin-right: 5px">编辑</Button>
          <Button type="error" size="small" @click="handleDictData(row)">字典数据</Button>
        </template>
      </Table>
      <Page
        :total="total"
        show-total
        :page-size="search.limit"
        :current="search.page"
        :page-size-opts="[10, 20, 30, 50]"
        @on-change="pageChange"
        @on-page-size-change="limitChange"
        class-name="footer-page"
        show-elevator
        show-sizer
        placement="top"
        style="margin-top: 10px; text-align: right;"
      ></Page>
    </div>

    <!-- 新增/编辑对话框 -->
    <Modal v-model="modalVisible" :title="modalTitle" @on-ok="handleSubmit" @on-cancel="handleCancel">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="字典名称" prop="dictName">
          <Input v-model="formValidate.dictName" placeholder="请输入字典名称" />
        </FormItem>
        <FormItem label="字典类型" prop="dictType">
          <Input v-model="formValidate.dictType" placeholder="请输入字典类型" :disabled="isEdit" />
        </FormItem>
        <FormItem label="状态" prop="status">
          <RadioGroup v-model="formValidate.status">
            <Radio label="0">正常</Radio>
            <Radio label="1">停用</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formValidate.remark" type="textarea" :rows="4" placeholder="请输入备注" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { dictTypeList, addDictType, updateDictType, delDictType } from '@/api/system/dict-type.js'

export default {
  name: 'dict-type',
  data() {
    return {
      search: {
        dictName: '',
        dictType: '',
        status: '',
        page: 1,
        limit: 10
      },
      columns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: '字典编号', key: 'dictId', width: 100 },
        { title: '字典名称', key: 'dictName', minWidth: 150 },
        { title: '字典类型', key: 'dictType', minWidth: 150 },
        { title: '状态', slot: 'status', width: 100 },
        { title: '备注', key: 'remark', minWidth: 200 },
        { title: '创建时间', key: 'createTime', width: 180 },
        { title: '操作', slot: 'action', width: 200, fixed: 'right' }
      ],
      tableList: [],
      total: 0,
      selections: [],
      modalVisible: false,
      modalTitle: '',
      isEdit: false,
      formValidate: {
        dictId: null,
        dictName: '',
        dictType: '',
        status: '0',
        remark: ''
      },
      ruleValidate: {
        dictName: [{ required: true, message: '字典名称不能为空', trigger: 'blur' }],
        dictType: [{ required: true, message: '字典类型不能为空', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      dictTypeList(this.search).then(res => {
        const page = res.data.page
        this.tableList = page.records || []
        this.total = page.total || 0
      })
    },
    searchFn() {
      this.search.page = 1
      this.getList()
    },
    clearFn() {
      this.search = {
        dictName: '',
        dictType: '',
        status: '',
        page: 1,
        limit: 10
      }
      this.getList()
    },
    handleAdd() {
      this.modalTitle = '新增字典类型'
      this.isEdit = false
      this.formValidate = {
        dictId: null,
        dictName: '',
        dictType: '',
        status: '0',
        remark: ''
      }
      this.modalVisible = true
      this.$nextTick(() => {
        this.$refs.formValidate && this.$refs.formValidate.resetFields()
      })
    },
    handleEdit(row) {
      this.modalTitle = '编辑字典类型'
      this.isEdit = true
      this.formValidate = { ...row }
      this.modalVisible = true
    },
    handleSubmit() {
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          const api = this.isEdit ? updateDictType : addDictType
          api(this.formValidate).then(() => {
            this.$Message.success(this.isEdit ? '修改成功' : '新增成功')
            this.modalVisible = false
            this.getList()
          })
        }
      })
    },
    handleCancel() {
      this.modalVisible = false
    },
    handleSelectionChange(selection) {
      this.selections = selection
    },
    handleDelete() {
      const ids = this.selections.map(item => item.dictId)
      this.$Modal.confirm({
        title: '提示',
        content: `确定要删除选中的 ${ids.length} 条数据吗?`,
        onOk: () => {
          delDictType(ids).then(() => {
            this.$Message.success('删除成功')
            this.getList()
          })
        }
      })
    },
    handleDictData(row) {
      this.$router.push({
        path: '/system/dict-data',
        query: { dictType: row.dictType, dictName: row.dictName }
      })
    },
    pageChange(page) {
      this.search.page = page
      this.getList()
    },
    limitChange(limit) {
      this.search.limit = limit
      this.search.page = 1
      this.getList()
    }
  }
}
</script>

<style scoped lang="less">
</style>
